import CameraControls from 'camera-controls'

const MOUSE_LEFT = 1
const MOUSE_RIGHT = 2
const MOUSE_CHORD = MOUSE_LEFT | MOUSE_RIGHT

/**
 * Trackpad con 2 dedos (macOS) simula botón derecho → solo pan (TRUCK).
 * Ratón con izquierdo+derecho activa ROTATE|TRUCK → gira y mueve a la vez.
 * Mientras ambos botones están pulsados, desactivamos ROTATE para igualar al trackpad.
 */
export function bindMouseChordPanFix(
  controls: CameraControls,
  domElement: HTMLElement,
): () => void {
  let savedLeftAction: number | null = null

  const restoreLeft = () => {
    if (savedLeftAction === null) return
    controls.mouseButtons.left = savedLeftAction
    savedLeftAction = null
  }

  const sync = (buttons: number) => {
    if ((buttons & MOUSE_CHORD) === MOUSE_CHORD) {
      if (savedLeftAction === null) {
        savedLeftAction = controls.mouseButtons.left
        controls.mouseButtons.left = CameraControls.ACTION.NONE
      }
      return
    }
    restoreLeft()
  }

  const onPointerDown = (e: PointerEvent) => {
    if (e.pointerType !== 'mouse') return
    sync(e.buttons)
  }

  const onPointerMove = (e: PointerEvent) => {
    if (e.pointerType !== 'mouse') return
    sync(e.buttons)
  }

  const onPointerUp = () => restoreLeft()

  const capture = { capture: true } as const

  domElement.addEventListener('pointerdown', onPointerDown, capture)
  domElement.addEventListener('pointermove', onPointerMove, capture)
  domElement.addEventListener('pointerup', onPointerUp, capture)
  domElement.addEventListener('pointercancel', onPointerUp, capture)
  window.addEventListener('pointerup', onPointerUp, capture)
  window.addEventListener('blur', onPointerUp)

  return () => {
    domElement.removeEventListener('pointerdown', onPointerDown, true)
    domElement.removeEventListener('pointermove', onPointerMove, true)
    domElement.removeEventListener('pointerup', onPointerUp, true)
    domElement.removeEventListener('pointercancel', onPointerUp, true)
    window.removeEventListener('pointerup', onPointerUp, true)
    window.removeEventListener('blur', onPointerUp)
    restoreLeft()
  }
}
